<template>
	<footer id="store-footer" class="store-footer" role="contentinfo">
		<div class="footer" :class="style()">
			<div class="full-container bottom">
				<img class="logo"
					alt="store logo image"
					src="../../assets/store-logo.png"
					width="95"
					aria-label="store logo">
				<div class="sections">
					<div class="flex-section section">
						<h4 class="section-title">Site map</h4>
						<div class="section-group">
							<a href="//brewedawakenings.us/">HOME</a>
							<a href="//brewedawakenings.us/menu">MENU</a>
							<a href="//brewedawakenings.us/about-us">ABOUT US</a>
							<a href="//brewedawakenings.us/locations">LOCATIONS</a>
							<a href="//brewedawakenings.us/roastery">ROASTERY</a>
							<a href="//brewedawakenings.us/employment">EMPLOYMENT</a>
						</div>
					</div>
					<div class="flex-section section">
						<h4 class="section-title">Contact us</h4>
						<div class="section-group">
							<a href="//brewedawakenings.us/contact">GET IN TOUCH</a>
						</div>
					</div>
					<div id="social-section" class="flex-section section">
						<h4 class="section-title">Connect with us</h4>
						<div class="section-group social-icon-container">
							<a href="//www.facebook.com/brewedawakeningscoffeeroasters"
								aria-label="Brewed Awakenings on Facebook"
								target="_blank"
								rel="noopener">
								<BaseIcon :classNames="['social-icon']" icon="facebook" size="1x" />
							</a>
							<a href="//www.instagram.com/brewed_awakenings/"
								aria-label="Brewed Awakenings on Instagram"
								target="_blank"
								rel="noopener">
								<BaseIcon :classNames="['social-icon']" icon="instagram" size="1x" />
							</a>
							<a href="//twitter.com/BrewedRoasters"
								aria-label="Brewed Awakenings on Twitter"
								target="_blank"
								rel="noopener">
								<BaseIcon :classNames="['social-icon']" icon="twitter" size="1x" />
							</a>
						</div>
					</div>
				</div>
				<div class="sections-bottom">
					<div class="full-width">
						<span class="highlight">Brewed Awakenings Coffee Roasters is a family owned business offering customers a local source for hand-roasted coffee and fresh baked goods. With seven locations spanning from the Vancouver/Portland area to Sunriver and Bend, Oregon, there's always an Awakenings just around the corner.<br></span>
						© COPYRIGHT BREWED AWAKENINGS COFFEE ROASTERS, ALL RIGHTS RESERVED
					</div>
				</div>
			</div>
		</div>
		<tp-footer />
	</footer>
</template>

<script>
import TPFooter from '@/components/footer/TPFooter';
import footerMixin from '@Mixin/footerMixin';

export default {
	mixins: [footerMixin],
	components: {
		'tp-footer': TPFooter,
	},
	methods: {
		style() {
			const mobile = this.$isMobile;
			return {
				mobile,
				desktop: !mobile,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
	@import '@style-vars';

	.logo {
		border-radius: 50%;
		margin-left: 20px;
	}

	.nav-columns {
		display: flex;
		justify-content: space-around;
		align-items: flex-start;
		.nav-item {
			a {
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.social-links-section {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 2em 3em;
		margin: auto;
		max-width: 30em;
		.social-link-item {
			a {
				display: flex;
				align-items: center;
				color: #fff;
				font-weight: bold;
				svg {
					fill: #fff;
					margin: 1em;
				}
			}
		}
	}
	@include desktop {
		.nav-columns {
			justify-content: flex-start;
			&:first-child {
				margin-left: 3em;
			}
			nav {
				flex: 1;
			}
		}
	}
	@include mobile {
		.social-links-list {
			align-items: flex-start;
			flex-direction: column;
		}
		.footer-logo {
			margin-right: 0;
			.logo {
				max-width: 120px;
				margin-left: 20px;
			}
		}
	}

	h4.section-title {
		font-size: 1.1em;
		margin-bottom: 2em;
	}

	.container-image {
		position: relative;
		top: -50px;
		left: 1em;

		max-width: 200px;
		max-height: 200px;

		opacity: 0.5;
		z-index: 0;
	}
	.footer-legal--mobile {
		text-align: center;
		color: #fff;
		font-weight: bold;
		a {
			color: $storeButtonColor;
		}
	}

	.flex-section {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex-wrap: wrap;
		padding: 0;
		margin: 20px 40px 20px 20px;
	}

	.sections {
		display: flex;
		align-items: baseline;
		flex-wrap: wrap;
	}

	.section-group {
		display: flex;
		flex-direction: column;
		a {
			font-weight: bold;
			color: #d9ae00;
		}
	}

	.section-group.social-icon-container {
		flex-direction: row;
		a {
			margin-right: 10px;
		}
	}

	.sections-bottom {
		margin: 20px;
		.highlight {
			color: #C59D5F;
		}
	}

	.site-links {
		display: flex;
		justify-content: space-evenly;
	}

	.site-links img {
		margin-right: 4em;
	}

	.social-links {
		display: flex;
		justify-content: space-evenly;
	}

	.social-links .social-link {
		border: 1px #999 solid;
		min-height: 40px;
		min-width: 40px;
		padding: 8px;
		margin-right: 1em;
		transition: 300ms all;
	}

	.social-links .social-link a {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
	}

	.social-links .social-link:hover {
		background-color: #333333;
	}

	.social-links .social-link:hover a {
		color: #fff;
	}

	.link-separator {
		background-color: #b0c149;
	}

	.flex-section.mobile .site-links {
		display: flex;
		justify-content: space-between;
		flex-direction: row-reverse;
		padding: 1em 0;
	}

	.flex-section.mobile .site-links img {
		top: 0;
		margin: auto;
	}
	/* --- */

	#store-footer {
		background-color: #fafafa;
	}

	#store-footer li {
		padding: 3px 0px;
	}

	.store-footer.side-bar {
		margin-left: 20vw;
		width: 80vw;
	}

	#store-footer.desktop-size {
		margin-top: 40px;
		padding-bottom: 0;
	}

	#store-footer.mobile {
		position: relative;
		margin-top: 40px;
		padding-top: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/footer/AppFooter.vue